export default __webpack_public_path__ + "static/media/rabbit10.915a0a8c.gif";